var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pb-0"},_vm._l((_vm.faqList),function(item,index){return _c('faq-card',{key:index,attrs:{"item":item,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }